<template>
    <div class="comment-list">
        <!-- title -->
        <div class="commnet-title">
            <div class="title">댓글</div>
            <div class="count">{{ totalCommentCount }}</div>
        </div>

        <!-- commnet list -->
        <div class="comment-section">
            <div class="comment-input">
                <input class="no-outline" type="text" :placeholder="$t('common.placeholder')" @keyup.enter="registComment" v-model="comment" />
                <div class="comment-input-button" @click="registComment">
                    <img src="/assets/player/comment-write.png" width="18" height="16" />
                </div>
            </div>
            <ul class="comment-list">
                <li class="reply-list-group" v-for="comment in commentList">
                    <div class="comment-block comment" v-if="comment.reply_no === null">
                        <div class="left">
                            <img v-if="comment.profile_image_url != null" :src="comment.profile_image_url" width="30" height="30" />
                            <img v-else src="https://ba8hb5guu4.ecn.cdn.ofs.kr/base/image/common/avata.png" width="30" height="30" />
                        </div>
                        <div class="right">
                            <div class="title">
                                <div v-if="comment.comment_nickname !== ''">{{ comment.comment_nickname }}<span>{{ comment.comment_regist_date | convertDateYYYYMMDD }}</span></div>
                                <div v-else>{{ comment.comment_member_name }}<span>{{ comment.comment_regist_date | convertDateYYYYMMDD }}</span></div>
                                <ion-button v-if="comment.comment_member_no === member.member_no" mode="ios" expand="block" fill="clear" shape="round" size="small" color="medium" @click="deleteComment(comment.board_no)">삭제</ion-button>
                                <ion-button v-else mode="ios" expand="block" fill="clear" shape="round" size="small" color="medium" @click="commentReport(comment.comment_no)">신고</ion-button>
                            </div>
                            <div class="comment">
                                {{ comment.comment }}
                            </div>
                            <div class="footer">
                                <best interest-div="31" :related-no="comment.comment_no" />
                                <img src="/assets/player/comment-point.png" width="4" height="4" />
                                <ion-button mode="ios" expand="block" fill="clear" shape="round" size="small" color="dark" @click="registReply(comment.comment_no)">답글</ion-button>
                            </div>
                        </div>
                    </div>
                    <div class="comment-block" v-else>
                        <div class="left" style="text-align: right;">
                            <img src="/assets/player/comment-reply.png" width="8" height="11" />
                        </div>
                        <div class="right">
                            <div class="title">
                                <div v-if="comment.reply_nickname !== ''">{{ comment.reply_nickname }} <span style="color: #666668">{{ comment.reply_regist_date | convertDateYYYYMMDD }}</span></div>
                                <div v-else>{{ comment.reply_member_name }} <span style="color: #666668">{{ comment.reply_regist_date | convertDateYYYYMMDD }}</span></div>
                                <ion-button v-if="comment.reply_member_no === member.member_no" mode="ios" expand="block" fill="clear" shape="round" size="small" color="medium" @click="deleteComment(comment.board_no)">삭제</ion-button>
                                <ion-button v-else mode="ios" expand="block" fill="clear" shape="round" size="small" color="medium" @click="replyReport(comment.reply_no)">신고</ion-button>
                            </div>
                            <div class="comment">
                                {{ comment.comment }}
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import * as biz from '../../utils/biz';
    import * as ajax from "../../utils/ajax";
    import * as utils from "../../utils/utils";
    import * as alert from '../../utils/alert'
    import Best from "../interest/best";

    export default {
        name: 'CommentList',
        components: {Best},
        props: {
            courseNo: Number
        },
        data() {
            return {
                member: {},
                comment: "",
                commentList: [
                    {
                        "comment": "",
                        "comment_no": 0,
                        "best_comment": 0,
                        "comment_member_name": "",
                        "reply_member_name": "",
                        "profile_image_url": "",
                        "comment_regist_date": "",
                        "reply_regist_date": "",
                        "reply_no": 0
                    }
                ]
            }
        },
        created() {
            if (biz.isLogin(this))
                this.getUserInfo();
        },
        mounted() {
        },
        methods: {
            getUserInfo() {
                ajax.Get(this, "/api/member/member/", function(ref, data) {
                    ref.member = data;
                });
            },
            refreshCommentList() {
                ajax.Get(this, "/api/board/comment/course/" + this.courseNo, function(ref, data) {
                    ref.comment = "";
                    ref.commentList = data;
                });
            },
            // 신규댓글 등록
            registComment(event) {
                const params = {
                    course_no: this.courseNo,
                    comment: this.comment
                };
                ajax.Post(this, "/api/board/comment/", params, function(ref, data) {
                    alert.alert("댓글이 등록되었습니다.", "확인");
                    ref.refreshCommentList();
                });
            },
            // 답글등록
            registReply(commentNo) {
                this.$emit("showReplyComment", commentNo);
            },
            // 댓글 신고
            commentReport(commentNo) {
                this.$emit("showReportComment", commentNo, 0);
            },
            // 답글 신고
            replyReport(replyNo) {
                this.$emit("showReportComment", 0, replyNo);
            },
            // 댓글 삭제
            deleteComment(board_no) {
                const url = "/api/board/comment/" + board_no;
                alert.alertConfirm(this, "삭제하시겠습니까?", "확인", '취소', function(ref) {
                    ajax.Delete(ref, url, function (ref, data) {
                        alert.alert("삭제되었습니다.", "확인");
                        ref.refreshCommentList();
                    });
                });
            }
        },
        computed: {
            totalCommentCount() {
                let totalCount = 0;
                this.commentList.forEach(function(comment) {
                    if (comment.reply_no === null)
                        totalCount += 1;
                });

                return totalCount;
            }
        },
        watch: {
            'courseNo': function(val, oldVal) {
                this.refreshCommentList();
            }
        },
        filters: {
            // Filter definitions
            minuteToStringFormat(value) {
                return utils.minuteToStringFormat(value);
            },
            thousandSeparator(value) {
                return utils.thousandSeparator(value);
            },
            convertDateYYYYMMDD(value) {
                return utils.convertDateYYYYMMDD(value);
            }
        }
    }
</script>

<style scoped lang="scss">
    div.comment-list {
      padding-top: 1.5em;
        padding-bottom: 20px;
        //background-color: $seventh-color;
    }

    div.commnet-title {
        padding: 14px 24px 10px 24px;

        div.title {
            float: left;
            height: 14px;
          font-size: 14px;
            margin-right: 9px;
            font-weight: $font-weight500;
            line-height: 16px;
        }
        div.count {
            float: left;
            height: 16px;
            font-size: $font-base14;
            line-height: 16px;
            color:$primary-color;

        }
    }
    div.commnet-title::after {
        display: block;
        content: '';
        clear: both;
    }

    div.comment-section {
        margin: 0 24px;
        border-top: 1px solid $line-secondary-color;
        font-size: $font-base14;

        .comment-input {
            display: flex;
            margin: 10px 0;
            border: 1px solid $line-secondary-color;

            input {
                flex: 1;
                border: 0;
                height: 48px;
                padding: 15px;
                overflow: hidden;
            }
            .comment-input-button {
                width: 32px;
                background-color: #fff;
                padding-top: 16px;
            }
        }

        ul.comment-list {
            list-style: none;
            margin: 0 auto;
            padding: 0 0;

            div.comment-block.comment {
                padding-top: 18px;
                border-top: 1px solid $line-secondary-color;
            }

            div.comment-block {
                display: flex;
                margin-bottom: 20px;

                div.left {
                    width: 40px;
                    margin-right: 10px;
                    img {
                        border-radius: 50%;
                    }
                }
                div.right {
                    flex: 1;
                    div.title {
                        display: flex;
                        justify-content: space-between;

                        span {
                            margin: 0 0 0 10px;
                            font-size: $font-base12;
                            color: $font-fourth-color;
                        }
                        ion-button {
                            width: 40px;
                            height: 15px;
                        }
                    }
                    div.footer {
                        margin-top: 5px;

                        display: flex;
                        align-items: center;

                        div.best {
                            margin-right: 15px;
                        }

                        ion-button {
                            width: 50px;
                        }
                    }
                }
            }

        }
    }
</style>
